import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { useUserByUuidQuery } from "@/common/api/user/use-user-by-uuid.query";
import { userIsEditableGuest } from "@/common/helpers/user-is-editable-guest";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { Loader, LoaderSize } from "@/components/ui/loader";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { UserDetailView } from "@/views/user-detail/user-detail.view";
import { Redirect, Route, Switch, useParams } from "wouter";
import { InviteGuestView } from "./invite-guest/invite-guest.view";
import { UpdateGuestView } from "./update-guest/update-guest.view";
import { UserView } from "./user.view";

export function UserRoutes() {
  const ability = useAbility();
  const userUuidRegex = generateUuidV4Regex({ paramName: "userUuid" });
  const userUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "User");

  return (
    <Switch>
      <Route path={userUpdateUuidRegex} component={canManage ? GuestUpdateView : ForbiddenView} />
      <Route path={userUuidRegex} component={UserDetailView} />
      <Route path={"/invite-guest"} component={canManage ? InviteGuestView : ForbiddenView} />
      <Route path={"/"} component={UserView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function GuestUpdateView() {
  const params = useParams<{ uuid: string }>();
  const { data: user, isPending } = useUserByUuidQuery(params.uuid ?? "");

  if (isPending) {
    return (
      <div className="flex min-h-100 items-center justify-center">
        <Loader size={LoaderSize.Medium} />
      </div>
    );
  }

  if (!userIsEditableGuest(user)) {
    return <RedirectToUserDetail />;
  }

  return <UpdateGuestView />;
}

function RedirectToUserDetail() {
  const params = useParams<{ uuid: string }>();
  return <Redirect to={`~/masterdata/user/${params.uuid}`} replace />;
}
